import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-4 border-orange-500 shadow-2xl"
      style={{ maxWidth: '100vw', overflowX: 'hidden' }}
    >
      <div className="w-full" style={{ padding: '16px 20px', boxSizing: 'border-box' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="flex-1">
              {/* Title */}
              <h3 className="font-bold text-gray-800 mb-2" style={{ fontSize: '16px' }}>
                👉 Wij gebruiken cookies
              </h3>

              {/* Text */}
              <p className="text-gray-600" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                We gebruiken cookies om je ervaring te verbeteren en onze website goed te laten functioneren. Je kunt zelf kiezen welke cookies je accepteert. Meer informatie vind je in ons <Link to="/privacy" className="text-orange-600 hover:underline font-semibold">privacybeleid</Link>.
              </p>
            </div>

            {/* Buttons - responsive layout */}
            <div className="flex flex-col sm:flex-row gap-3 sm:flex-shrink-0">
              <button
                onClick={handleDecline}
                className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold rounded-lg transition w-full sm:w-auto"
                style={{
                  padding: '10px 24px',
                  fontSize: '14px',
                  border: 'none',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap'
                }}
              >
                Weigeren
              </button>
              <button
                onClick={handleAccept}
                className="text-white font-semibold rounded-lg transition transform hover:scale-105 w-full sm:w-auto"
                style={{
                  padding: '10px 24px',
                  fontSize: '14px',
                  border: 'none',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  background: 'radial-gradient(circle at center, #ff8a3d 0%, #f06c28 45%, #d4551b 100%)',
                }}
              >
                Accepteren
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
